import { render, staticRenderFns } from "./CardItemInfo.vue?vue&type=template&id=76cdf57d&scoped=true&"
import script from "./CardItemInfo.vue?vue&type=script&lang=js&"
export * from "./CardItemInfo.vue?vue&type=script&lang=js&"
import style0 from "./CardItemInfo.vue?vue&type=style&index=0&id=76cdf57d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cdf57d",
  null
  
)

export default component.exports